export class AsideNavigation {
	constructor(node, opts = {}) {
		this.node = node;
		this.items = Array.from(
			this.node.querySelectorAll(".aside-navigation__item")
		);
		this.headings = this.items.map((item) => {
			const href = item.querySelector("a")?.getAttribute("href");
			if (href && href.startsWith("#")) {
				return document.getElementById(href.slice(1));
			}
			return null;
		});
		this._scrollTimeout = null;
		this._lastScroll = 0;
		this.init();
	}

	init() {
		// Add active class to first item
		if (this.items.length) {
			this.setActive(this.items[0]);
		}

		// Click event for navigation items
		this.items.forEach((item) => {
			item.addEventListener("click", (e) => {
				this.setActive(item);
			});
		});

		// Throttled scroll event for headings
		window.addEventListener("scroll", () => this.throttledOnScroll());
	}

	throttledOnScroll() {
		const now = Date.now();
		if (now - this._lastScroll > 100) {
			// 100ms throttle
			this._lastScroll = now;
			this.onScroll();
		} else {
			clearTimeout(this._scrollTimeout);
			this._scrollTimeout = setTimeout(() => {
				this._lastScroll = Date.now();
				this.onScroll();
			}, 100);
		}
	}

	setActive(activeItem) {
		this.items.forEach((item) =>
			item.classList.remove("aside-navigation__item--active")
		);
		activeItem.classList.add("aside-navigation__item--active");
	}

	onScroll() {
		// Find the heading closest to (but above) the top of the viewport
		let closestIdx = -1;
		let minDist = Infinity;
		const offset = 100; // adjust as needed for sticky headers
		for (let i = 0; i < this.headings.length; i++) {
			const heading = this.headings[i];
			if (heading) {
				const rect = heading.getBoundingClientRect();
				const dist = Math.abs(rect.top - offset);
				if (rect.top - offset <= 0 && dist < minDist) {
					minDist = dist;
					closestIdx = i;
				}
			}
		}
		if (closestIdx !== -1) {
			this.setActive(this.items[closestIdx]);
		} else if (this.items.length) {
			this.setActive(this.items[0]);
		}
	}
}

document.addEventListener("DOMContentLoaded", () => {
	window.asideNavigationInstances = Array.from(
		document.querySelectorAll(".aside-navigation")
	).map((node) => new AsideNavigation(node));
});
